import { render, staticRenderFns } from "./PlansBankDetails.vue?vue&type=template&id=a9d29a12"
import script from "./PlansBankDetails.vue?vue&type=script&lang=js"
export * from "./PlansBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports